import GamesListModel from "./GamesListModel";

export default class GameByIdModel extends GamesListModel {
  public adContent: string = null;
  public labels: Record<string, string> = null;
  public customFields: Record<string, string> = null;
}
